import Loader from "@/components/common/ui/loader";
import React from "react";

const InstallScriptLoading = () => {
  return (
    <div className="absolute top-0 bottom-0 left-0 right-0 bg-white rounded-md">
      <div className="flex flex-col h-full text-center center-center">
        <div>
          <Loader size="large" block />
        </div>

        <div className="mt-4">
          <div className="font-semibold">스크립트 설치 중</div>
          <div className="mt-1 text-cb-gray-500">잠시만 기다려 주세요.</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(InstallScriptLoading);
